import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './historicalPercentageChangeCapsulePreview.png';
import backPreview from './historicalPercentageChangeCapsuleBackPreview.png';

export const historicalPercentageChangeCapsuleDescription: DropdownTooltipText =
    {
        body: (
            <>
                <div>
                    The Historical Percentage Change capsule provides volume and
                    price historical data for a stock
                </div>
            </>
        ),
        previews: [
            {
                title: 'Chart',
                src: preview,
                altText: 'historical-percentage-change-preview',
            },
            {
                title: 'Back',
                src: backPreview,
                altText: 'historical-percentage-change-back-preview',
            },
        ],
    };
